<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col>
        <b-card>
          <b-row class="pb-4" align-v="center">
            <b-col cols="12" class="text-center">
              <span style="font-size:18px;font-weight:500">Filter</span>
            </b-col>
            <b-col cols="12" class="text-center py-2">
              <span class="p-2">
                <b-btn size="sm" variant="success" @click="newPoly">New Polygon</b-btn>
              </span>
              <span v-if="sorted.length > 0 " class="p-2">
                <b-btn size="sm" variant="success">
                  <download-excel
                    :data="json_data"
                    :fields="json_fields"
                    name="filename.xls"
                  >Download Excel Data</download-excel>
                </b-btn>
              </span>
            </b-col>
            <b-col cols="12">
              <b-row class="text-center" align-v="center">
                <b-col>
                  <span>Incident From :</span>
                </b-col>
                <b-col>
                  <b-form-input v-model="fromDate" type="date" id="date"></b-form-input>
                </b-col>
                <b-col>
                  <span>Incident To :</span>
                </b-col>
                <b-col>
                  <b-form-input v-model="toDate" type="date" id="date"></b-form-input>
                </b-col>
                <b-col>
                  <b-btn size="sm" variant="primary" @click="getData" style="width:200px">Submit</b-btn>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div id="map"></div>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
var marker;
var drawingManager;
var all_overlays = [];
export default {
  components: {},
  data() {
    return {
      ServerError: false,
      appLoading: false,
      totalCount: 0,
      incident: [],
      map: null,
      oMarker: [],
      polygonArray: [],
      sorted: [],
      json_fields: {
        caseId: "caseid",
        BeenCut: "beencut",
        HaveBeenCut: "havebeencut",
        MightBeCut: "mightbecut",
        Location: "locationname",
        Latitude: "lat",
        Longitude: "lon",
        Date: "createddate",
        Reason: "mightbecutreason",
        Description: "description",
        UserId: "userid",
        Name: "name",
        Phone: "phone",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      fromDate: null,
      toDate: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        // url: "/incident/getall",
        url: "/incident/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          type: "All",
          keyword: null,
          count: 0,
          page: 0,
          from: this.fromDate,
          to: this.toDate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.incident = response.data.data;
          this.totalCount = this.incident.length;
          this.loadMap();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    loadMap() {
      var mapCanvas = document.getElementById("map");
      var mapOptions = {
        center: new google.maps.LatLng(20.5937, 78.9629),
        zoom: 5,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      };
      var vm = this;
      this.map = new google.maps.Map(mapCanvas, mapOptions);
      for (var i = 0; i < this.totalCount; i++) {
        var caseid = this.incident[i].caseid;
        var beencut = this.incident[i].beencut;
        var havebeencut = this.incident[i].havebeencut;
        var mightbecut = this.incident[i].mightbecut;
        var lon = this.incident[i].location[0];
        var lat = this.incident[i].location[1];
        var id = this.incident[i]._id;
        var latlngset = new google.maps.LatLng(lat, lon);
        var iconBase = "http://snakebiteinitiative.in/r4.png";
        marker = new google.maps.Marker({
          map: this.map,
          position: latlngset,
          icon: iconBase,
        });
        this.oMarker[i] = {
          m: marker,
          c: id,
        };
        var content =
          "<table align='center'><tr><td><b style='color:red;'>Case Id :&nbsp;" +
          caseid +
          "</b></td></tr><tr><td><b>Been cut:&nbsp;" +
          beencut +
          "</b></td></tr><tr><td><b>Have been cut:&nbsp;" +
          havebeencut +
          "</b></td></tr><tr><td><b>Might be cut:&nbsp;" +
          mightbecut +
          "</b></td></tr><tr><td>" +
          "<button class='btn btn-danger btn-sm' onclick='doFunction(\"" +
          id +
          "\")'>View Incident</button></td></tr></table>";
        var infowindow = new google.maps.InfoWindow({
          maxWidth: 200,
        });
        google.maps.event.addListener(
          marker,
          "click",
          (function (marker, content, infowindow) {
            return function () {
              infowindow.setContent(content);
              infowindow.open(this.map, marker);
            };
          })(marker, content, infowindow)
        );
      }
      window.doFunction = function (id) {
        // location.pathname = "/Incidents/" + id;
        vm.$router.push("/Incidents/" + id);
      };

      this.polygonArray = [];
      drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["polygon"],
        },
        polygonOptions: {
          editable: true,
        },
      });
      drawingManager.setMap(this.map);
      var vm = this;
      google.maps.event.addListener(
        drawingManager,
        "overlaycomplete",
        function (event) {
          all_overlays.push(event);
          event.overlay.set("editable", false);
          drawingManager.setMap(null);
        }
      );
      google.maps.event.addListener(
        drawingManager,
        "polygoncomplete",
        function (polygon) {
          for (var i = 0; i < polygon.getPath().getLength(); i++) {
            var poly = polygon.getPath().getAt(i).toUrlValue(6);
            vm.polygonArray.push(poly);
          }
          vm.getDocs();
        }
      );
    },
    newPoly() {
      this.polygonArray = [];
      this.sorted = [];
      for (var i = 0; i < all_overlays.length; i++) {
        all_overlays[i].overlay.setMap(null);
      }
      all_overlays = [];
      drawingManager.setMap(null);
      drawingManager.setMap(this.map);
    },

    getDocs() {
      var temp = [];
      let op = this.polygonArray.map((e) => {
        let temp = e.split(",");
        return { lat: Number(temp[0]), lng: Number(temp[1]) };
      });
      var temp = op;
      var Triangle = new google.maps.Polygon({ paths: temp });
      var tempr = [];
      var tempi = [];
      var res = [];
      for (var i = 0; i < this.incident.length; i++) {
        var lat = this.incident[i].location[1];
        var lng = this.incident[i].location[0];
        res[i] = google.maps.geometry.poly.containsLocation(
          new google.maps.LatLng(
            this.incident[i].location[1],
            this.incident[i].location[0]
          ),
          Triangle
        );
        if (res[i] === true) {
          if (!this.incident[i].addedby.name) {
            this.incident[i].addedby.name = "-";
          }
          var tyu = {
            caseid: this.incident[i].caseid,
            beencut: this.incident[i].beencut,
            havebeencut: this.incident[i].havebeencut,
            mightbecut: this.incident[i].mightbecut,
            locationname: this.incident[i].locationname,
            lat: this.incident[i].location[0],
            lon: this.incident[i].location[1],
            createddate: this.formatDate(this.incident[i].createddate),
            mightbecutreason: this.incident[i].mightbecutreason,
            description: this.incident[i].description,
            userid: this.incident[i].addedby.userid,
            name: this.incident[i].addedby.name,
            phone:
              String(this.incident[i].addedby.phonePrefix) +
              " " +
              String(this.incident[i].addedby.phone),
          };
          tempi.push(tyu);
          this.sorted = tempi;
          this.json_data = tempi;
        }
      }
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style scoped>
#map {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>